import './CardEntryContent.css';

import { useTranslate } from '../../../../../hooks/context/useTranslate';
import { useModalKeyboard } from '../../../../../hooks/shortcuts/useModalKeyboard';
import BasicEntryContent from '../BasicEntryContent/BasicEntryContent';
import EntryActionButtons from '../EntryActionButtons/EntryActionButtons';

export interface CardEntryContentProps {
  allowManual?: boolean;
  isSubmitting: boolean;
  handleAction: (action: () => void | Promise<void>) => void | Promise<void>;
  submitEntryValue: (value: string) => void | Promise<void>;
  cancelModalAction: () => void | Promise<void>;
}

// Card readers are not available in this client — the card number can only be
// entered manually (when the error allows it), otherwise cancel is the only option.
const CardEntryContent = ({
  allowManual,
  isSubmitting,
  handleAction,
  submitEntryValue,
  cancelModalAction,
}: CardEntryContentProps) => {
  const { t } = useTranslate();

  // With manual entry the nested BasicEntryContent registers later and becomes
  // the topmost keyboard handler, so no handlers are needed here.
  useModalKeyboard({
    onEscape: allowManual
      ? undefined
      : () => handleAction(cancelModalAction),
  });

  return (
    <div className="card-entry-content">
      <div className="card-entry-info">{t('entryError.readerUnavailable')}</div>
      {allowManual ? (
        <BasicEntryContent
          valueType="string"
          isSubmitting={isSubmitting}
          handleAction={handleAction}
          submitEntryValue={submitEntryValue}
          cancelModalAction={cancelModalAction}
        />
      ) : (
        <EntryActionButtons onCancel={() => handleAction(cancelModalAction)} />
      )}
    </div>
  );
};

export default CardEntryContent;
